'use client';
import { IllustrationCloud } from '@/components/IllustrationCloud';
import { Box, Stack } from '@mui/material';
import treydIcon from '@treyd-io/treyd-ui/assets/img/logo.svg';
import { Col } from '@treyd-io/treyd-ui/components/Grid/Col';
import { Row } from '@treyd-io/treyd-ui/components/Grid/Row';
import Image from 'next/image';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack width="100%" minHeight="100vh" spacing={0} bgcolor="info.50">
      <Box
        width="1.75rem"
        height="1.75rem"
        position="absolute"
        top={32}
        left={32}>
        <Image src={treydIcon} alt="Treyd" width={28} height={28} />
      </Box>
      <Row flexGrow={1}>
        <Col
          maxWidth={{ sm: 300, md: 450, lg: 591 }}
          width="100%"
          display={{ xs: 'none', sm: 'unset' }}>
          <Stack justifyContent="center" alignItems="center" height="100%">
            <IllustrationCloud
              style={{ fill: 'none' }}
              sx={{
                color: 'grey.900',
                width: 236,
                height: 525,
              }}
              viewBox="0 0 236 525"
            />
          </Stack>
        </Col>
        <Col xs>
          <Stack
            alignItems="center"
            justifyContent="center"
            flexGrow={1}
            bgcolor="background.default"
            width={'100%'}
            paddingX={2}
            paddingY={5}
            height={'100%'}
            sx={{
              borderTopLeftRadius: { sm: 32 },
              borderBottomLeftRadius: { sm: 32 },
            }}>
            {children}
          </Stack>
        </Col>
      </Row>
    </Stack>
  );
};

export default Layout;
